import { Component, ViewEncapsulation, Input, HostBinding } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';

import { Batch } from '../../../../order/models/batch';
import { UserService } from '../../../services/user.service';
import { UNDERSCORE } from '../../../utils/constant';
import { User } from '../../../models/user';
import { PRODUCT_OPTIONS, ORDER_NUMBER_OPTIONS, WEIGHT_OPTIONS } from '../../../models/list';
import { ARTICLE, CUSTOMER, GROSS } from '../../../models/settings';
import { DimensionPipe } from '../../../pipes/format-dimension.pipe';
import { NumberPipe } from '../../../pipes/number.pipe';

@Component({
	selector: 'copo-result-batch-card',
	templateUrl: './result-card-batch.component.html',
	styleUrl: './result-card-batch.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		MatRippleModule,
		RouterLink,
		TranslateModule,
		NgIf,
		MatIconModule,
		NumberPipe,
		DimensionPipe,
	],
})
export class ResultCardBatchComponent {
	@HostBinding('class.passthrough') readonly passthrough = true;

	@Input() batch!: Batch;
	user: User;
	productDisplay: keyof typeof PRODUCT_OPTIONS = ARTICLE;
	orderDisplay: keyof typeof ORDER_NUMBER_OPTIONS = CUSTOMER;
	weightDisplay: keyof typeof WEIGHT_OPTIONS = GROSS;

	constructor(private readonly userService: UserService) {
		this.user = this.userService.user;
	}

	getBatchWeight(batch: Batch) {
		return batch.qtyBatchGross;
	}

	getProductName(batch: Batch) {
		return batch.steelgradeDescription || UNDERSCORE;
	}

	getProductLabel() {
		return 'order.steelgrade';
	}

	getOrderValue(batch: Batch) {
		return batch.customerOrderNumber === ''
			? UNDERSCORE
			: `${ batch.customerOrderNumber }/${ batch.customerOrderItemNumber }`;
	}

	getOrderName() {
		return 'order.customer.order.number';
	}

	getIconStatus(batch: Batch) {
		switch (batch.statusGroup) {
		case '0':
			return 'in_production';
		case '1':
			return '';
		case '2':
			return 'in_stock';
		case '3':
			return 'in_transit';
		case '4':
			return '';
		case '5':
			return 'delivered';
		}
		return '';
	}

	getBatchStatusLocation(batch: Batch) {
		let statusLocation = batch.statusDescription;
		if (batch.currentLocationDescription) {
			statusLocation = `${ statusLocation } - ${ batch.currentLocationDescription }`;
		}
		return statusLocation;
	}
}
